import { ColDef } from 'ag-grid-community';

import { SupressKeyboard } from './suppress-keyboard';
import { DvKeyboard } from '@devinco/ui';

export const vtDefaultColDef: ColDef = {
  enableCellChangeFlash: true,
  floatingFilter: true,
  resizable: true,
  sortable: true,
  width: 140,
  enableRowGroup: true,
  suppressKeyboardEvent: params => {
    if (params.event.key === DvKeyboard.Delete) {
      return SupressKeyboard.delete(params);
    } else if (params.event.key === DvKeyboard.Enter) {
      return SupressKeyboard.enter(params);
    } else {
      return false;
    }
  },
};
